import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setCpdSource, setLabelModalOpen } from 'shared/actions/cpd';
import { CpdInfoCard, CpdInfoSection } from 'shared/components/CpdUnderDescription';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { CARDS_DATA, SOURCE_MAP } from 'shared/containers/CpdUnderDescriptionContainer/constants';
import { selectIsCpdLabel } from 'shared/selectors/cpd/cpd';
import { ECpdLabelModalView } from 'shared/types/cpd/cpd';

export const CpdUnderDescriptionContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();

  const isCpdLabelEnabled = config.get<boolean>('cpd.DealLabel.Enabled') || false;
  const isCpdLabel = useSelector(selectIsCpdLabel);

  const handleCardClick = React.useCallback(
    (modalView: ECpdLabelModalView, source: string) => {
      dispatch(setCpdSource(source));
      dispatch(setLabelModalOpen({ isOpen: true, modalView }));
    },
    [dispatch],
  );

  if (!isCpdLabelEnabled || !isCpdLabel) {
    return null;
  }

  return (
    <CpdInfoSection>
      {CARDS_DATA.map((card, index) => (
        <CpdInfoCard onClick={() => handleCardClick(card.id, SOURCE_MAP[card.id])} key={card.id + index} {...card} />
      ))}
    </CpdInfoSection>
  );
};
